const SERVERMESSAGE = {
  WRONG_OTP_CODE: "کد وارد شده اشتباه است",
  EXPIRE_OTP_CODE: "کد وارد شده منقضی شده است",
  wrongUpdateKmPiece:
    "کیلومتر تعویض قطعه نبایداز آخرین کیلومتر سرویس قطعه کمتر باشد",
  successUpdateKmPiece: "سرویس قطعه با موفقیت ثبت گردید",
  WRONG_UPDATE_KM_CURRENT:
    "کیلومتر کارکرد خودرو نبایداز آخرین کیلومتر سرویس کمتر باشد",
  IllogicalDataUpdateKmCurrent:
    "کیلومتر خودرو نامعقول وارد شده است، آیا از صحت آن مطمئن هستید؟",
  kmCurrentUpdatedSuccesfully: "کیلومتر فعلی خودرو با موفقیت بروزرسانی شد",
  successAddCar: "خودرو با موفقیت در مجموعه اسکارپین ثبت گردید",
  SUCCESS_DESTROY_CAR: "خودرو با موفقیت حذف گردید",
  successUpdateDetailCar: "اطلاعات با موفقیت ویرایش گردید",
  SUCCESS_SET_SERVICE_PLACE: "سرویس در محل با موفقیت ثبت گردید",
  SUCCESS_CANCEL_SERVICE_PLACE: "سرویس در محل با موفقیت لغو گردید",

  SUCCESS_SET_DATA: "اطلاعات با موفقیت ثبت گردید",
  SUCCESS_EDIT_DATA: "اطلاعات با موفقیت ویرایش گردید",
  INVALID_CARID_FIND_CAR: "شناسه خودرو یافت نشد",
  WRONG_REGISTER_CODE: "کد وارد شده صحیح نیست",
  EXPIRE_REGISTER_CODE: "کد وارد شده منقضی شده است",
  NOT_FOUND_IDENTIFIID: "کد دعوت وارد شده اشتباه است",
  NOT_FOUND_CAR: "خودرو یافت نشد",
  SERVICE_SET_WRONG_KMREPLACE: "کیلومتر وارد شده اشتباه است",
  SUCCESS_TICKET_REGISTER: "تیکت با موفقیت ثبت گردید",
  UNABLE_SET_IDENITY_ID: "کد دعوت وارد شده اشتباه است",
  DUPLICATE_REPAIR: "شناسه صنفی وارد شده در سامانه موجود می\u200cباشد",
  NOT_FOUND_REPAIR: "شناسه صنفی یافت نشد",
  NOT_FOUND_USER: "کاربر یافت نشد",
  NOT_FOUND_INQUIRY: "استعلامی یافت نشد",
  WRONG_KM_REPLACE: "کیلومتر وارد شده اشتباه است",
  DUPLICATE_CAR: "شماره پلاک وارد شده در سامانه موجود می\u200cباشد",

  SERVICE_NOT_ACTIVE: "سرویس مورد نظر در حال حاضر غیر فعال می‌باشد",
  WRONG_PAY_AND_BILL_ID: "شناسه قبض یا شناسه پرداخت اشتباه است",

  REQUEST_BAD: "خطا بوجود آمده، لطفا مجدد تلاش نمایید",
};

const serverErrorMessage = (code) => {
  switch (code) {
    case 1001:
      return "خطایی بوجود آمده است";
    case 1002:
      return "خطا، لطفا با پشتیبانی تماس بگیرید";
    case 1003:
      return "دسترسی به شبکه اینترنت را بررسی و مجدد تلاش نمایید";
    case 1004:
      return "خطایی در ارتباط با سرور بوجود آمده است";
    case 1005:
      return "خطا بوجود آمده، لطفا مجدد تلاش نمایید";
    case 1006:
      return "به\u200cدلیل تنظیم نبودن ساعت/تاریخ تلفن همراه شما امکان ارائه خدمات وجود ندارد";
    case 1007:
      return "خطا بوجود آمده، لطفا پس از چند دقیقه تلاش نمایید";
    case 1008:
      return "ورود شما منقضی شده است، مجددا وارد شوید";
    default:
      return "خطایی بوجود آمده است، مجدد تلاش نمایید";
  }
};
export { SERVERMESSAGE, serverErrorMessage };
